import React from 'react';

const ProjectDetail = ({ project, isOpen, onClose, getYoutubeVideoId }) => {
  if (!project) return null;

  const videoId = project.video ? getYoutubeVideoId(project.video) : null;

  return (
    <div className={`project-modal ${isOpen ? 'open' : ''}`}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>{project.title}</h2>
          <button onClick={onClose} className="close-button" aria-label="Close modal">×</button>
        </div>
        <div className="modal-body">
          {project.description && (
            <div className="project-description">
              <p>{project.description}</p>
            </div>
          )}
          
          {/* YouTube Video Embed - with performance optimizations */}
          {videoId && (
            <div className="video-container">
              <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                title={`${project.title} video`}
                width="560"
                height="315"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy" // Lazy loading for better performance
              ></iframe>
            </div>
          )}

          {/* Project screenshots or additional images */}
          {project.images && project.images.length > 0 && (
            <div className="project-images">
              {project.images.map((image, index) => (
                <img 
                  key={index} 
                  src={image} 
                  alt={`${project.title} screenshot ${index + 1}`} 
                  loading="lazy" // Lazy loading for images too
                />
              ))}
            </div>
          )}
          
          {/* Technologies used */}
          {project.technologies && project.technologies.length > 0 && (
            <div className="project-technologies">
              <h3>Technologies Used</h3>
              <ul>
                {project.technologies.map((tech, index) => (
                  <li key={index}>{tech}</li>
                ))}
              </ul>
            </div>
          )}
          
          {/* Project links */}
          <div className="project-links">
            {project.github && (
              <a href={project.github} target="_blank" rel="noopener noreferrer" className="btn btn-github">
                View on GitHub
              </a>
            )}
            {project.liveDemo && (
              <a href={project.liveDemo} target="_blank" rel="noopener noreferrer" className="btn btn-demo">
                Live Demo
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;